// utils/exportToExcel.js
import * as XLSX from 'xlsx';

export const exportSitesToExcel = (sitesData, fileName) => {
  let worksheetData = [];

  sitesData.forEach(siteData => {
    // Ajouter les informations de base du site
    worksheetData.push({
      Name: siteData.name,
      Environment: siteData.environnement,
      WP_Version: siteData.wp_version,
      Update_Mode: siteData.updateModeWP,
      Last_Input_Date: siteData.date_input,
      Note: siteData.text_input,
      Site_URL: siteData.siteUrl,
      Item_Type: '',
      Item_Name: '',
      Active: '',
      Version: '',
      Update_Mode: '',
    });

    // Ajouter les informations des plugins
    siteData.plugins.forEach(plugin => {
      worksheetData.push({
        Name: '',
        Environment: '',
        WP_Version: '',
        Update_Mode: '',
        Last_Input_Date: '',
        Note: '',
        Site_URL: '',
        Item_Type: 'Plugin',
        Item_Name: plugin.name,
        Active: plugin.active ? 'Yes' : 'No',
        Version: plugin.version,
        Update_Mode: plugin.updateModePLUG,
      });
    });

    // Ajouter les informations des thèmes
    siteData.themes.forEach(theme => {
      worksheetData.push({
        Name: '',
        Environment: '',
        WP_Version: '',
        Update_Mode: '',
        Last_Input_Date: '',
        Note: '',
        Site_URL: '',
        Item_Type: 'Theme',
        Item_Name: theme.name,
        Active: theme.active ? 'Yes' : 'No',
        Version: theme.version,
        Update_Mode: '',
      });
    });

    // Ajouter une ligne vide pour séparer les sections des sites
    worksheetData.push({});
  });

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "SitesData");

  // Save to file
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
